<div class="bg-white p-5 rounded-2xl border border-gray-100 shadow-xs mb-5">
  <h4 class="text-sm font-medium mb-3 flex items-center text-gray-700">
    <img src="assets/img/iconos/users.svg" alt="" height="18" width="18" class="mr-2">
    Resumen de usuarios
  </h4>
  @if (!cargando) {
    <div class="grid grid-cols-3 gap-3">
      <app-tarjeta-resumen-cantidad [titulo]="'Total usuarios'"
                                    [cantidad]="numeroUsuarios"
                                    [bgColor]="'bg-blue-50'"
                                    [textColor]="'text-blue-700'">
      </app-tarjeta-resumen-cantidad>
      <app-tarjeta-resumen-cantidad [titulo]="'Grupos'"
                                    [cantidad]="numeroGrupos"
                                    [bgColor]="'bg-green-50'"
                                    [textColor]="'text-green-700'">
      </app-tarjeta-resumen-cantidad>
      <app-tarjeta-resumen-cantidad [titulo]="'Perfiles'"
                                    [cantidad]="numeroPerfiles"
                                    [bgColor]="'bg-purple-50'"
                                    [textColor]="'text-purple-700'">
      </app-tarjeta-resumen-cantidad>
    </div>
  } @else {
    <div class="grid grid-cols-3 gap-3">
      <div class="bg-gray-200 p-3 rounded-xl">
        <span class="block h-3 w-24 bg-gray-100 rounded-sm mb-2"></span>
        <span class="block h-6 w-12 bg-gray-100 rounded-sm"></span>
      </div>
      <div class="bg-gray-200 p-3 rounded-xl">
        <span class="block h-3 w-24 bg-gray-100 rounded-sm mb-2"></span>
        <span class="block h-6 w-12 bg-gray-100 rounded-sm"></span>
      </div>
      <div class="bg-gray-200 p-3 rounded-xl">
        <span class="block h-3 w-24 bg-gray-100 rounded-sm mb-2"></span>
        <span class="block h-6 w-12 bg-gray-100 rounded-sm"></span>
      </div>
    </div>
  }
</div>
